<template>
    <v-container text-xs-center te mt-5 pt-5 class="d-flex justify-center align-center" style="min-height: 80vh">


        <!-- Error Alert -->

        <v-layout v-if="error" row wrap>
            <v-flex xs12 sm6 md6>
                <form-alert :message="error.message"></form-alert>
            </v-flex>
        </v-layout>


        <v-layout row wrap>
            <v-flex xs12 sm6 md6 mx-auto>
                <h1 class="pb-3">إنشاء حساب</h1>
                    <v-form v-model="isFormValid" lazy-validation ref="form" @submit.prevent="handleSignUp">
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field :rules="nameRules" v-model="name" prepend-icon="mdi-face"
                                    label="اسم المستخدم" type="text" required outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field :rules="emailRules" v-model="email" prepend-icon="mdi-email"
                                    label="البريد الالكتروني" type="email" required outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field :rules="passwordRules" v-model="password" prepend-icon="mdi-information"
                                    label="كلمة المرور" type="password" required outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field :rules="passwordRules" v-model="passwordConfirmation"
                                    prepend-icon="mdi-information" label="تأكيد كلمة المرور" type="password" required
                                    outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-btn class="mb-5" :loading="loading" :disabled="!isFormValid || loading" color="#EFAA42"
                                    type="submit">
                                    <template v-slot:loader>
                                        <span class="custom-loader">
                                            <v-icon light>mdi-cached</v-icon>
                                        </span>
                                    </template>
                                    تسجيل</v-btn>
                                <h3>لديكم حساب مسبقا؟ <router-link style="color: #EFAA42" to="/signin">تسجيل الدخول</router-link>
                                </h3>
                            </v-flex>
                        </v-layout>

                    </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'

    export default {
        name: 'Signup',
        data() {
            return {
                isFormValid: true,
                name: "",
                email: "",
                password: "",
                passwordConfirmation: "",
                nameRules: [
                    // Check if name in input
                    name => !!name || "الاسم مطلوب",
                    // Make sure name is less than 10 char
                    name => name.length < 30 || "الاسم يجب أن يكون أقل من 30 حرف"

                ],
                emailRules: [
                    email => !!email || "الايميل مطلوب",
                    email => /.@+./.test(email) || 'يجب ان يكون البريد الاكتروني صحيح'
                ],
                passwordRules: [
                    // Check if password in input
                    password => !!password || "كلمة المرور مطلوبة",
                    // Make sure name is less than 10 char
                    password => password.length >= 4 || "كلمة المرور يجب أن تكون 7 حروف على الأقل",
                    confirmation => confirmation === this.password || "كلمتي المرور يجب أن يكونا متطابقين"

                ]
            }
        },
        computed: {
            ...mapGetters(['user', 'loading', 'error'])
        },
        watch: {
            user(value) {
                // If user value changes, redirect to home page
                if (value) {
                    this.$router.push('/')
                }
            }
        },
        methods: {
            handleSignUp() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('signup', {
                        name: this.name,
                        email: this.email,
                        password: this.password
                    })
                }

            }
        }
    }
</script>